<p-table [value]="exclusiones || []" [paginator]="true" [rows]="5" responsiveLayout="stack">
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Trámite</th>
      <th>Nombre Tramite</th>
      <th>Solicitud</th>
      <th>Fase</th>
      <th>Estado</th>
      <th>Fecha creación</th>
      <th>Fecha modificación</th>
      <th>Acción</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-excluido>
    <tr>
      <tr>
      <td>{{ excluido.idTramiteExclusion }}</td>
      <td>{{ excluido.idTramite }}</td>
      <td>{{ excluido.nombreTramite || '-' }}</td>
      <td>{{ excluido.idSolicitud }}</td>
      <td>{{ excluido.idFase }}</td>
      <td>{{ excluido.estado ? 'Activo' : 'Inactivo' }}</td>
      <td>{{ excluido.fechaCreacion }}</td>
      <td>{{ excluido.fechaModificacion || '-' }}</td>
      <td>
        <button
            pButton
            icon="pi pi-check"
            class="p-button-rounded p-button-success p-button-outlined p-mr-2"
            [disabled]="excluido.estado || cargandoEstado.has(excluido.idTramiteExclusion)"
            [loading]="cargandoEstado.has(excluido.idTramiteExclusion) && !excluido.estado"
            (click)="cambiarEstado(excluido, true)">
        </button>
        <button
            pButton
            icon="pi pi-times"
            class="p-button-rounded p-button-danger p-button-outlined p-mr-2"
            [disabled]="!excluido.estado || cargandoEstado.has(excluido.idTramiteExclusion)"
            [loading]="cargandoEstado.has(excluido.idTramiteExclusion) && excluido.estado"
            (click)="cambiarEstado(excluido, false)">
        </button>
        <!-- Boton de opciones de tramites excluidos para Admin -->
        <!-- <button
            pButton
            type="button"
            icon="pi pi-ellipsis-v"
            class="p-button-rounded p-button-secondary p-button-outlined"
        >
        </button> -->
      </td>
    </tr>
  </ng-template>
</p-table>
